import axios from "axios";
import { config } from "../../../../config";


export const googleLogin = (args) => {
    return new Promise((resolve, reject) => {

        let params = {};
        if ( args?.shouldSelectAccount ) params.shouldSelectAccount = true;

        axios.get(`${config.LOIS_BACKEND_URL}/google/api/login`, {params})
            .then((response) => {
                console.log('response: ',response);
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });     
    })     
}


export const loginCallback = (code) => {
    return new Promise((resolve, reject) => {

        const params = {
            authenticationCode: code,
        }

        axios.get(`${config.LOIS_BACKEND_URL}/google/api/callback`, {params})
            .then((response) => {
                console.log('response: ',response);
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });
    })
}



export const getCustomerResourceNames = (accessToken) => {
    return new Promise((resolve, reject) => {

        const params = {
            accessToken: accessToken,
        }

        axios.get(`${config.LOIS_BACKEND_URL}/google/api/getCustomerResourceNames`, {params})
            .then((response) => {
                console.log('response: ',response);
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });
    })
}



export const getCustomerDetailts = (resource_name, accessToken) => {
    return new Promise((resolve, reject) => {

        const params = {
            resource_name: resource_name,
            accessToken: accessToken,
        }

        axios.get(`${config.LOIS_BACKEND_URL}/google/api/getCustomerDetailts`, {params})
            .then((response) => {
                console.log('response: ',response);
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });
    })
}


export const getCustomerClients = (resource_name, accessToken) => {
    return new Promise((resolve, reject) => {

        const params = {
            resource_name: resource_name,
            accessToken: accessToken,
        }

        axios.get(`${config.LOIS_BACKEND_URL}/google/api/getCustomerClients`, {params})
            .then((response) => {
                console.log('response: ',response);
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });
    })
}


export const getClientCampaigns = (client_resource_name, managerId, accessToken) => {
    return new Promise((resolve, reject) => {
        const resource_name = `customers/${client_resource_name.split('/')[3]}`

        const params = {
            resource_name: resource_name,
            managerId: managerId,
            accessToken: accessToken,
        }

        axios.get(`${config.LOIS_BACKEND_URL}/google/api/getClientCampaigns`, {params})
            .then((response) => {
                console.log('response: ',response);
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });
    })
}


export const getCampaignData = (clientId, managerId, campaignId, accessToken, dates) => {
    return new Promise((resolve, reject) => {
        const resource_name = `customers/${clientId}`

        const params = {
            resource_name: resource_name,
            managerId: managerId,
            campaignId: campaignId, 
            accessToken: accessToken,
            since: dates?.sinceDate,
            until: dates?.untilDate,
        }

        axios.get(`${config.LOIS_BACKEND_URL}/google/api/getCampaignData`, {params})
            .then((response) => {
                console.log('response: ',response);
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });
    })
}


